module.exports = ":host /deep/ > * {\n    padding: 20px;\n}\n\n"